// extracted by mini-css-extract-plugin
export default {"popup_container":"Popup_popup_container__JI6Sn","popup_footer":"Popup_popup_footer__C1bU+"};